import api from './client';

export const storesApi = {
  getAll: (params = {}) => api.get('/stores', { params }),
  getOne: (id) => api.get(`/stores/${id}`),
};
